import { services } from '@/mocks/services';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function ServicesSection() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal();
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollReveal();

  return (
    <section id="our-services" className="bg-nv-black py-20 md:py-28 lg:py-32">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div
            ref={headerRef}
            className={`flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20 transition-all duration-700 ${
              headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <div>
              <span className="text-nv-muted text-sm tracking-widest uppercase mb-4 block">
                Our Services
              </span>
              <h2 className="font-serif text-white text-3xl md:text-4xl lg:text-5xl font-medium leading-tight">
                Software Development /
                <br />
                IT Consulting /
                <br />
                Digital Marketing
              </h2>
            </div>
            <div className="flex flex-row gap-3 md:flex-col md:items-end lg:flex-row lg:items-center">
              <a
                href="#contact-us"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact-us')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap px-6 py-3 rounded-full bg-white text-nv-black text-sm font-medium hover:bg-white/90 transition-colors cursor-pointer"
              >
                Get Started
              </a>
              <a
                href="#contact-us"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact-us')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="whitespace-nowrap px-6 py-3 rounded-full border border-white/30 text-white text-sm hover:border-white/60 transition-colors cursor-pointer"
              >
                Contact Us
              </a>
            </div>
          </div>

          <div
            ref={cardsRef}
            className="flex flex-col gap-4"
          >
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {services.slice(0, 3).map((service, index) => (
                <div
                  key={service.id}
                  className={`bg-nv-gray rounded-2xl p-6 md:p-7 flex flex-col gap-4 group hover:bg-nv-muted/20 hover:-translate-y-1 transition-all duration-300 cursor-default transition-all duration-700 ${
                    cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                  }`}
                  style={{ transitionDelay: cardsVisible ? `${index * 120}ms` : '0ms' }}
                >
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${service.icon} text-white text-xl group-hover:scale-110 transition-transform duration-300`} />
                  </div>
                  <div>
                    <h3 className="text-white text-base font-medium leading-snug mb-2">
                      {service.title}
                    </h3>
                    <p className="text-white/50 text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {services.slice(3, 6).map((service, index) => (
                <div
                  key={service.id}
                  className={`bg-nv-gray rounded-2xl p-6 md:p-7 flex flex-col gap-4 group hover:bg-nv-muted/20 hover:-translate-y-1 transition-all duration-300 cursor-default transition-all duration-700 ${
                    cardsVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                  }`}
                  style={{ transitionDelay: cardsVisible ? `${(index + 3) * 120}ms` : '0ms' }}
                >
                  <div className="w-10 h-10 flex items-center justify-center">
                    <i className={`${service.icon} text-white text-xl group-hover:scale-110 transition-transform duration-300`} />
                  </div>
                  <div>
                    <h3 className="text-white text-base font-medium leading-snug mb-2">
                      {service.title}
                    </h3>
                    <p className="text-white/50 text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
